import type { useUserStore } from "@/stores/user";

const PINIA_USER_STORAGE_KEY = "user";

/**
 * Pinia persist can lag behind the first router guard in a new tab. Rehydrate the
 * company user store from localStorage so authenticated routes work across tabs.
 */
export function restorePersistedCompanySessionIfNeeded(
  userStore: ReturnType<typeof useUserStore>
): boolean {
  if (userStore.token?.trim()) {
    return true;
  }
  try {
    const raw = localStorage.getItem(PINIA_USER_STORAGE_KEY);
    if (!raw) {
      return false;
    }
    const persisted = JSON.parse(raw) as { token?: string | null };
    const token = persisted.token?.trim();
    if (!token) {
      return false;
    }
    userStore.$patch(persisted);
    return Boolean(userStore.token?.trim());
  } catch {
    return false;
  }
}
